import { DialogTitle as MuiDialogTitle } from '@mui/material';
import { shouldNotForwardProps } from '../../helpers';
import { styled } from '../muiReexports';
export const DialogTitleWithIcon = styled(MuiDialogTitle, shouldNotForwardProps('withIcon'))(({ withIcon }) => ({
    ...(withIcon && {
        alignItems: 'center',
        justifyContent: 'flex-start',
        gap: '1rem',
    }),
}));
